// Signs (MB.1). PURE (ENG-1). A sign holds four short text lines. This owns the
// line-count / per-line length normalization; the host stores the text per cell
// (a lightweight block-entity) and the client draws it + the edit screen.

/** A sign has four lines… */
export const SIGN_LINES = 4;
/** …each capped at this many characters (Java ~15 wide). */
export const SIGN_LINE_MAX = 15;

/** Coerce arbitrary input into exactly SIGN_LINES lines, each ≤ SIGN_LINE_MAX
 *  characters (missing lines become empty; overflow is truncated; newlines drop). */
export function normalizeSignText(lines: readonly string[]): string[] {
  const out: string[] = [];
  for (let i = 0; i < SIGN_LINES; i++) {
    out.push((lines[i] ?? '').replace(/[\r\n]/g, '').slice(0, SIGN_LINE_MAX));
  }
  return out;
}

/** Whether a sign is blank (all four lines empty after normalization). */
export function isBlank(lines: readonly string[]): boolean {
  return normalizeSignText(lines).every((l) => l.length === 0);
}
